import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import CarGlassBanner from "../../../Assets/Product_Images/CarGlass/CarGlassBanner.jpg";
import carimg1 from "../../../Assets/Product_Images/CarGlass/carglass1.jpg";
import carimg2 from "../../../Assets/Product_Images/CarGlass/carglass2.jpg";
import carimg3 from "../../../Assets/Product_Images/CarGlass/carglass3.jpg";
import carimg4 from "../../../Assets/Product_Images/CarGlass/car1.jpg";
import carimg5 from "../../../Assets/Product_Images/CarGlass/car2.webp";
import { Link } from "react-router-dom";

const Architectural_glass = () => {
  return (
    <div>
      <Header />

      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${CarGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"

                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Car Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5 style={{ color: "#153fa4", fontFamily: "Segoe UI, sans-serif", fontSize: "40px", fontWeight: "700", marginBottom: "15px" }}>Car Glass</h5>
                <p>
                  We offer a premium selection of car glass solutions that
                  combine safety, clarity, and durability. Our range includes
                  high-performance laminated windshield and windscreen glasses,
                  designed to meet industry standards while ensuring effective
                  protection and long-lasting performance.
                </p>
                <p>
                  <strong>Car Laminate Windshield Glass:</strong> Crafted using
                  top-quality laminated glass, this windshield is designed to
                  offer superior strength and impact resistance. The transparent
                  and rectangular structure provides optimal visibility while
                  maintaining the aesthetic appeal of the vehicle. Trusted by
                  leading automotive manufacturers, our windshields are ideal
                  for all types of passenger vehicles.
                </p>
                <p>
                  <strong>Automotive Laminate Windscreen Glass:</strong>{" "}
                  Engineered for advanced safety and clarity, our automotive
                  laminated windscreen glass is manufactured with precision and
                  tested for durability. With a smooth glass finish and high
                  resistance to external stress, it ensures passenger protection
                  even under extreme conditions. Suitable for modern vehicles,
                  this product offers both functionality and style.
                </p>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={carimg1} className="CarImage1" style={{width : "180px" , height : "180px"}} alt="Bus" />
                 <img src={carimg5} className="CarImage1" style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={carimg2} className="CarImage1" style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={carimg3} className="CarImage1" style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={carimg4} className="CarImage1" style={{width : "180px" , height : "180px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End */}

      <Footer />
    </div>
  );
};

export default Architectural_glass;
